import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { Maker } from '@root/entities/trade'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import type { TypeHelper } from '@blade/std-lib'
import type { ServicesMakerTopTradersListParams as ServicesMakerTopTradersListParamsDto } from '@blade/trade-api-client'
import type { PairAddress } from '@root/entities/pair'

interface FetchTopTradersRequestActionParams
  extends TypeHelper.OmitKey<
    ServicesMakerTopTradersListParamsDto,
    'network' | 'pairAddress'
  > {
  pairAddress: PairAddress
  network: Network.Network
}

export const fetchTopTradersRequestAction = action(
  async (ctx, { network, ...req }: FetchTopTradersRequestActionParams) => {
    const {
      tradeApiClient,
      environment: {
        assets: { avatarsHost },
      },
    } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.services.servicesMakerTopTradersList, [
        {
          ...req,
          network: Network.toDto(network),
        },
      ]),
    )

    const mappedResult = pipe(
      result,
      Result.map((it) =>
        it.map((dto) => Maker.fromRankedDto(dto, avatarsHost)),
      ),
      Result.mapError(ApiError.fallbackToUnknown),
    )
    return mappedResult
  },
  'fetchTopTradersRequestAction',
)
